import { CartsResponse, ReducedCartData } from '../../models/Carts'

export const extractReducedCartData = (cartResponse: CartsResponse): ReducedCartData => {
  const data = cartResponse.data
  const attributes = cartResponse.data.attributes

  const reducedCartData: ReducedCartData = {
    id: data.id,
    organizationId: String(attributes.organizationId),
    campaignId: String(attributes.campaignId),
    amount: String(attributes.grandTotal),
    currency: attributes.currency,
    items: attributes.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        unitPrice: item.unitPrice,
        qty: item.qty,
        frequency: item.recurringProperties?.frequency || 'one-time',
      }
    }),
  }

  return reducedCartData
}
